<template>
    <div class="flex flex-col gap-5 items-center justify-between h-full">
      <div class="flex flex-col gap-5 items-center">
        <picture>
          <NuxtImg 
            class="w-72 h-72"
            src="/_nuxt3-static/events/date-request-success.svg"
          />
        </picture>
        <div class="flex flex-col gap-2 text-center px-8 md:px-32">
          <div class="text-h6 font-bold leading-7">
            {{ $t('dateRequest.generalSuccessMessage') }}
          </div>
          <div class="text-sm text-stone-600">
            {{ $t('dateRequest.generalSuccessSubMessage') }}
          </div>
        </div>

        <div
          class="mx-auto flex items-center gap-2 rounded-full bg-lime-100 px-3 py-1.5 text-lime-800"
        >
          <Clock class="w-4 h-4" />
          <span class="text-sm font-medium">
            {{ $t('dateRequest.generalSuccessResponseTimeBadge') }}
          </span>
        </div>
      </div>

      <div class="flex flex-col gap-3 rounded-2xl bg-gray-100 p-4">
        <div class="text-center text-sm font-semibold text-stone-800">
          {{ $t('dateRequest.generalSuccessShareQuestion') }}
        </div>
        <DateRequestShareOptions :page-title="pageTitle" :link="pageLink" />
      </div>

      <Button class="w-full font-semibold md:hidden" @click="handleOpenShare">
        {{ $t('dateRequest.generalSuccessShareEventButton') }}
      </Button>
    </div>
</template>

<script setup lang="ts">
import { Clock } from 'lucide-vue-next'

const eventData = useEventData()
const route = useRoute()

const event = computed(
  () => route.name?.split('___')[0] === 'e-eventPermalink' && eventData.value
)
const { t } = useI18n()

const pageTitle = computed(() =>
  event.value ? eventGetters.getTitle(event.value) : t('general.titles.index')
)

const fullLocalizedUrl = useFullLocalizedUrl()

const pageLink = computed(() =>
  event.value
    ? fullLocalizedUrl(
        '/' +
          encodeURIComponent(
            `${route.path}&utm_source=konfetti&utm_medium=share_event&utm_campaign=facebook`
          )
      )
    : import.meta.client && fullLocalizedUrl('/')
)

const handleOpenShare = () => {
  navigator?.share?.({
    title: pageTitle.value,
    url: pageLink.value,
  })
}
</script>
